import React, { useEffect, useState } from "react";
import citiesData from "../../cities/cities.json";
import MyGoogleMap from "../../components/MyGoogleMap";
import NavbarPag from "../../components/NavbarPag";
import { Any } from "react-spring";
import db from "../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  runTransaction,
  doc,
  addDoc,
  DocumentReference,
} from "firebase/firestore";
import { useData } from "../../contexts/DataContext";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../../atoms/dropdown";
import Loading from "../../atoms/loading";
import Modal from "../../atoms/modal";
import { text } from "stream/consumers";
import DropdownList from "../../atoms/dropdownList";

interface Option {
  value: string;
  label: string;
}

interface Data {
  doc: string;
  field: string;
  where: number;
}
interface DataDeliver {
  destino: string;
  bultos: string;
  email: string;
  fecha: number;
  fechaReceived: number;
  receivingBultos: number;
  receivingStatus: number;
  state: number;
  uuid: number;
}
interface DataOd {
  Centro_de_costos: string;
  Destino: string;
  alto: string;
  ancho: string;
  bultos: string;
  ciudad: string;
  contacto: string;
  destinatario: string;
  direccion: string;
  email: string;
  fecha: string;
  guia: string;
  id: number;
  kilos: string;
  largo: string;
  observaciones: string;
  time: { seconds: number; nanoseconds: number }; // Firebase Timestamp
  uuid: number;
}
interface odProps {
  cancel: React.Dispatch<React.SetStateAction<boolean>>;
  dataOd: DataOd;
  dataDeliver: DataDeliver;
  setDataOd: React.Dispatch<React.SetStateAction<DataOd>>;
  setDataDeliver: React.Dispatch<React.SetStateAction<DataDeliver>>;
  backAdmi: () => void;
  refOd?: DocumentReference;
  refDe?: DocumentReference;
}

const EditOd = ({
  cancel,
  dataOd,
  dataDeliver,
  setDataOd,
  setDataDeliver,
  refDe,
  refOd,
  backAdmi,
}: odProps) => {
  // Convertir el objeto a un array de opciones
  let lisState = ["INICIAL", "RETIRADO", "ENTREGADO", "NO ENTREGADO"];
  let state = ["Sin recibir", "Incompleto", "Completo"];
  const ciudadesArray: Option[] = Object.entries(citiesData).map(
    ([key, value]) => ({
      value: key,
      label: value,
    })
  );
  const stateArray: Option[] = lisState.map((value, index) => ({
    value: String(index),
    label: value,
  }));
  const stateBultosArray: Option[] = state.map((value, index) => ({
    value: String(index),
    label: value,
  }));
  const [errorOd, setErrorOd] = useState(true);

  const [destinatario, setDestinatario] = useState("");
  const [direccion, setDireccion] = useState("");
  const [contacto, setContacto] = useState("");
  const [bultos, setBultos] = useState("");
  const [bultosR, setBultosR] = useState("");
  const [kilos, setKilos] = useState("");
  const [alto, setAlto] = useState("");
  const [ancho, setAncho] = useState("");
  const [largo, setLargo] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [destino, setDestino] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [Centro_de_costos, setCentro_de_costos] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [titel, setTitel] = useState("");
  const [textButton, setTextButton] = useState("Cerrar");
  const [lastNumber, setLastNumber] = useState(0);
  const location = useLocation();
  const [destinoText, setDestinoText] = useState("");
  const [ciudadText, setCiudadText] = useState("");
  const [dateDeliver, setDateDeliver] = useState(new Date());
  const [stateO, setStateO] = useState("");
  const [stateB, setStateB] = useState("");
  const { rutInit, od } = useData();
  const [dataStateO, setSDtateO] = useState("");
  const [dataStateB, setSDtateB] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (rutInit === "") {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    setDestinatario(dataOd.destinatario);
    setDireccion(dataOd.direccion);
    setContacto(dataOd.contacto);
    setBultos(dataOd.bultos);
    setKilos(dataOd.kilos);
    setAlto(dataOd.alto);
    setAncho(dataOd.ancho);
    setLargo(dataOd.largo);
    setObservaciones(dataOd.observaciones);
    setCentro_de_costos(dataOd.Centro_de_costos);
    setCiudad(dataOd.ciudad);
    setDestino(dataOd.Destino);
    let texD = `${dataOd.Destino}:${citiesData[dataOd.Destino as keyof typeof citiesData]}`;
    setDestinoText(texD);
    let texD2 = `${dataOd.ciudad}:${citiesData[dataOd.ciudad as keyof typeof citiesData]}`;
    setCiudadText(texD2);
    let tStateO = `${dataDeliver.state}:${stateArray[dataDeliver.state].label}`;
    setStateO(tStateO);
    setSDtateO(dataDeliver.state.toString());
    let tStateB = `${dataDeliver.receivingStatus}:${stateBultosArray[dataDeliver.receivingStatus].label}`;
    setStateB(tStateB);
    setSDtateB(dataDeliver.receivingStatus.toString());
    setBultosR(dataDeliver.receivingBultos.toString());
    //console.log("dataDeliver:", dataDeliver);
    let dateDeliverT = new Date(dataDeliver.fechaReceived);
    //console.log("dateDeliverT", dateDeliverT);
    setDateDeliver(dateDeliver);

    console.log(tStateB);
  }, [dataOd]);

  //let lisState = ["INICIAL", "RETIRADO", "ENTREGADO", "NO ENTREGADO"];

  const isFloat = (value: string, field: string) => {
    if (!/^\d+(\.\d+)?$/.test(value)) {
      setMessage(
        `El campo ${field} solo permite números enteros o decimales con punto`
      );
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };

  const isInteger = (value: string, field: string) => {
    if (!/^\d+$/.test(value)) {
      setMessage(`El campo ${field} solo permite números enteros`);
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const errorBulto = () => {
    if (Number(bultosR) > Number(bultos)) {
      setMessage(`El valor de Bultos Recibidos no puede ser mayor que Bultos`);
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const errorBulto2 = () => {
    if (bultosR !== "0") {
      setMessage(`El valor de Bultos Recibidos no puede 0`);
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const [odValue, setOdValue] = useState(od);
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    set: React.Dispatch<React.SetStateAction<string>>
  ) => {
    //console.log(event.target.value)
    set(event.target.value);
  };
  const empty = (value: string, field: string) => {
    if (value === "") {
      setMessage(`Valor requerido ${field}`);
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const hasForbiddenCharacters = (value: string, field: string) => {
    if (/[\"'\+\-=]/.test(value)) {
      setMessage(
        `El campo ${field} no puede contener los caracteres: " ' + - =`
      );
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const isValidLength = (
    value: string,
    min: number,
    max: number,
    field: string
  ) => {
    if (value.length < min || value.length > max) {
      setMessage(
        `El campo ${field} debe tener entre ${min} y ${max} caracteres`
      );
      setTitel("Error");
      setShowModal(true);
      return true;
    }
    return false;
  };
  const crear = () => {
    const fieldLis = [
      { value: destinatario, text: "Destinatario" },
      { value: direccion, text: "Direccion" },
      { value: contacto, text: "Numero Contacto" },
      { value: bultos, text: "Bultos" },
      { value: bultosR, text: "Bultos Recibidos" },
      { value: kilos, text: "Kilos" },
      { value: alto, text: "Alto" },
      { value: ancho, text: "Ancho" },
      { value: observaciones, text: "Observaciones" },
      { value: ciudad, text: "Ciudad" },
      { value: destino, text: "Destino" },
      { value: Centro_de_costos, text: "Centro de costos" },
    ];
    for (let i in fieldLis) {
      if (
        fieldLis[i].text === "Observaciones" ||
        fieldLis[i].text === "Numero Contacto"
      ) {
        continue;
      }
      if (empty(fieldLis[i].value, fieldLis[i].text)) {
        return;
      }
    }
    for (let i in fieldLis) {
      if (
        fieldLis[i].text === "Observaciones" ||
        fieldLis[i].text === "Centro de costos"
      ) {
        if (fieldLis[i].value !== "") {
          if (hasForbiddenCharacters(fieldLis[i].value, fieldLis[i].text)) {
            return;
          }
        }
      } else if (fieldLis[i].text === "Numero Contacto") {
        if (fieldLis[i].value !== "") {
          if (isInteger(fieldLis[i].value, fieldLis[i].text)) {
            return;
          }
        }
      } else if (
        fieldLis[i].text === "Direccion" ||
        fieldLis[i].text === "Destinatario"
      ) {
        if (
          hasForbiddenCharacters(fieldLis[i].value, fieldLis[i].text) ||
          isValidLength(fieldLis[i].value, 2, 255, fieldLis[i].text)
        ) {
          return;
        }
      } else if (
        fieldLis[i].text === "Destino" ||
        fieldLis[i].text === "Ciudad"
      ) {
        continue;
      } else if (fieldLis[i].text === "Bultos Recibidos") {
        if (fieldLis[i].value !== "") {
          if (isInteger(fieldLis[i].value, fieldLis[i].text) || errorBulto()) {
            return;
          }
        }
      } else {
        if (isFloat(fieldLis[i].value, fieldLis[i].text)) {
          return;
        }
      }
    }
    updateOD();
  };

  const getDate = async () => {
    const uuidRef = doc(db, "uuid", "1");
    try {
      await runTransaction(db, async (transaction) => {
        const sfDoc = await transaction.get(uuidRef);

        let newPopulation = sfDoc.data()?.uuid;
        setLastNumber(newPopulation);
        console.log(newPopulation);
        if (await newOrders(newPopulation)) {
          newPopulation = newPopulation + 1;
          transaction.update(uuidRef, { id: 0, uuid: newPopulation });
        }
      });
      //console.log("Transaction successfully committed!");
    } catch (e) {
      //console.log("Transaction failed: ", e);
    }
  };
  const newOrders = async (newPopulation: number) => {
    setLoading(true);
    const ordersRef = collection(db, "orders");
    const deliveries = collection(db, "deliveries");
    const ordersxusersRef = collection(db, "ordersxusers");
    var options: any = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };

    const now = new Date().toLocaleDateString("es-ES", options).toUpperCase();
    //console.log("trace dia", now);

    const dia = now.split("GMT")[0];
    let textOrder: any = [];
    let nunOr = 0;
    const timestam = new Date();
    const payload = {
      uuid: newPopulation,
      id: newPopulation,
      alto: alto,
      ancho: ancho,
      bultos: bultos,
      ciudad: ciudad,
      contacto: contacto,
      destinatario: destinatario,
      direccion: direccion,
      email: location.state.email,
      guia: `${newPopulation}`,
      kilos: kilos,
      largo: largo,
      observaciones: observaciones,
      fecha: dia,
      Destino: destino,
      time: timestam,
      Centro_de_costos: Centro_de_costos,
    };
    const timestamp = new Date().getTime();
    const payload2 = {
      uuid: newPopulation,
      fecha: timestamp,
      fechaReceived: 0,
      Destino: destino,
      state: 0,
      receivingStatus: 0,
      bultos: bultos,
      receivingBultos: 0,
      email: location.state.email,
    };
    addDoc(ordersRef, payload);
    addDoc(deliveries, payload2);
    addDoc(ordersxusersRef, { email: location.state.email, fecha: dia });

    const q = query(
      collection(db, "listClientNumberOrder"),
      where("email", "==", location.state.email)
    );
    //console.log(location.state.email);
    const numberOfOrder = await getDocs(q);
    //console.log("numberOfOrder:", numberOfOrder);
    const info: any = [];
    numberOfOrder.forEach((doc) => {
      info.push({ data: doc.data(), id: doc.id });
    });
    if (info.length !== 0) {
      const refOfOrder = doc(db, "listClientNumberOrder", info[0].id);
      //updateDoc(refOfOrder, { numero: info[0].data.numero + orders.length });
      try {
        await runTransaction(db, async (transaction) => {
          const sfDoc = await transaction.get(refOfOrder);
          const newUmber = sfDoc.data()?.numero + 1;
          transaction.update(refOfOrder, {
            numero: newUmber,
          });
        });
        //console.log("Transaction successfully committed!");
      } catch (e) {
        //console.log("Transaction failed: ", e);
      }
    }

    setLoading(false);
    setMessage(`Orden ${newPopulation} creada`);
    setTitel("Orden creada");
    setShowModal(true);
    setDestinatario("");
    setDireccion("");
    setCentro_de_costos("");
    setContacto("");
    setBultos("");
    setKilos("");
    setAlto("");
    setAncho("");
    setLargo("");
    setObservaciones("");

    return true;
  };

  const close = () => {
    cancel(false);
  };
  const getState = (data: string, label: string) => {
    /**
     * const [dataStateO, setSDtateO] = useState("");
  const [dataStateB, setSDtateB] = useState("");
     */
    //console.log(label);
    const datas = data.split(":");
    console.log(data);
    if (label === "Estado de la orden") {
      setStateO(data);
      setSDtateO(datas[0]);
    }
    if (label === "Estado los bultos") {
      setSDtateB(datas[0]);
      setStateB(data);
      console.log(datas[0]);
      if (datas[0] === "0") {
        setBultosR("0");
      } else if (datas[0] === "2") {
        setBultosR(bultos);
      }
    }
  };
  const getCity = (data: string, label: string) => {
    console.log(label);
    const datas = data.split(":");
    console.log(data);
    if (label === "Ciudad de Origen") {
      setCiudad(datas[0]);
      setCiudadText(data);
    } else {
      setDestino(datas[0]);
      setDestinoText(data);
    }
  };
  const updateOD = async () => {
    //refDe;
    //refOd;
    setLoading(true);
    try {
      await runTransaction(db, async (transaction) => {
        /*
        bultosR;
        dataStateO;
        dataStateB;
        bultos
        * */
        //const sfDoc = await transaction.get(refDe!);
        const lisDe = ["state", "receivingStatus", "receivingBultos"];

        let data: any = {};
        for (let i = 0; i < lisDe.length; i++) {
          if (lisDe[i] === "receivingStatus") {
            data[lisDe[i]] = Number(dataStateB);
          }
          if (lisDe[i] === "state") {
            data[lisDe[i]] = Number(dataStateO);
          }
          if (lisDe[i] === "receivingBultos") {
            data[lisDe[i]] = Number(bultosR);
          }
        }

        transaction.update(refDe!, data);
      });
    } catch (e) {}

    try {
      await runTransaction(db, async (transaction) => {
        /*
        bultosR;
        dataStateO;
        dataStateB;
        bultos
        * */
        const payload = {
          ciudad: ciudad,
          Destino: destino,
          destinatario: destinatario,
          direccion: direccion,
          Centro_de_costos: Centro_de_costos,
          bultos: bultos,
          kilos: kilos,
          alto: alto,
          ancho: ancho,
          largo: largo,
          contacto: contacto,
          observaciones: observaciones,
        };
        transaction.update(refOd!, payload);
      });
    } catch (e) {}
    setLoading(false);
    backAdmi();
  };

  return (
    <>
      {showModal && (
        <Modal
          message={message}
          titel={titel}
          onClick={() => setShowModal(false)}
          textButton={textButton}
        />
      )}
      <div className="bg-sky-600 p-2 text-white">
        Editar Orden {dataOd.uuid}
      </div>

      <article className=" bg-slate-50">
        <div className="flex p-4">
          <Dropdown
            value={ciudadText}
            primariOptions="-- Elige Ciudad --"
            label="Ciudad de Origen"
            options={ciudadesArray}
            onSelect={getCity}
            class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
          />
          <Dropdown
            value={destinoText}
            primariOptions="-- Elige Ciudad --"
            label="Ciudad de destino"
            options={ciudadesArray}
            onSelect={getCity}
            class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
          />
        </div>
        <div className="flex p-4">
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Destinatario
            </label>
            <input
              type="text"
              placeholder="Destinatario"
              value={destinatario} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setDestinatario)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Direccion
            </label>
            <input
              type="text"
              placeholder="Direccion"
              value={direccion} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setDireccion)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Centro de costos
            </label>
            <input
              type="text"
              placeholder="Centro de costos"
              value={Centro_de_costos} // Asignar el valor del estado al input
              onChange={(event) =>
                handleInputChange(event, setCentro_de_costos)
              }
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
        </div>

        <div className="flex p-4">
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Bultos
            </label>
            <input
              type="text"
              placeholder="Bultos"
              value={bultos} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setBultos)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Kilos
            </label>
            <input
              type="text"
              placeholder="Kilos"
              value={kilos} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setKilos)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Alto
            </label>
            <input
              type="text"
              placeholder="Alto"
              value={alto} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setAlto)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
        </div>

        <div className="flex p-4">
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Ancho
            </label>
            <input
              type="text"
              placeholder="Ancho"
              value={ancho} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setAncho)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Largo
            </label>
            <input
              type="text"
              placeholder="Largo"
              value={largo} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setLargo)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Numero Contacto
            </label>
            <input
              type="text"
              placeholder="Numero Contacto"
              value={contacto} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setContacto)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
        </div>

        <div className="flex p-4">
          <div className=" w-full">
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Observaciones
            </label>
            <input
              type="text"
              placeholder="Observaciones"
              value={observaciones} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setObservaciones)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-3/6 mr-4"
            />
          </div>
        </div>
      </article>
      <div className="bg-sky-600  p-2 text-white text-center">
        Datos del servicio
      </div>
      <article className=" bg-slate-50">
        <div className="flex p-4">
          <div>
            <div className="bg-gray-50  p-2.5  w-64 mr-4">Feche recogida:</div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700 mr-4 pl-2.5"
            >
              {dataDeliver.fechaReceived !== 0
                ? dateDeliver.toLocaleDateString("es-CL", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true, // Usa formato 24 horas
                  })
                : ""}
            </label>
          </div>
          <DropdownList
            value={stateO}
            label="Estado de la orden"
            options={stateArray}
            onSelect={getState}
            class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
          />
          <DropdownList
            value={stateB}
            label="Estado los bultos"
            options={stateBultosArray}
            onSelect={getState}
            class_name="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
          />
        </div>

        <div className="flex p-4">
          <div>
            <label
              htmlFor="dropdown-select"
              className="block font-medium text-gray-700"
            >
              Bultos Recibidos
            </label>
            <input
              type="text"
              placeholder="Bultos Recibidos"
              value={bultosR} // Asignar el valor del estado al input
              onChange={(event) => handleInputChange(event, setBultosR)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-64 mr-4"
            />
          </div>
        </div>

        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-10 mb-5"
          onClick={crear}
        >
          Guardar
        </button>
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-10 mb-5"
          onClick={close}
        >
          Cancelar
        </button>
      </article>
    </>
  );
};

export default EditOd;
